"use strict";

/* Copyright 2019-2021 The MathWorks, Inc. */
define(['dojo/_base/declare', 'dojo/Deferred', 'dojo/dom-construct', 'mw-html-utils/HtmlUtils', 'mw-remote/RemoteEndPointsManager', './utils/SendMessageUtil', './ReplaceUploadIframe'], function (declare, Deferred, domConstruct, HtmlUtils, RemoteEndPointsManager, SendMessageUtil, ReplaceUploadIframe) {
  return declare([], {
    constructor: function constructor() {},

    /**
     * Upload artifacts provided to Worker
     *
     * @param {FileList} artifactsList - List of files that have to be uploaded
     * @param {string} fsDest - Location where the file has to be uploaded
     * @param {object} endpoint - Contains the following:
     *                            endpoint: Url of the worker where the upload request is to be sent
     *                            computeSession and routingKey
     * @return {*} a deferred
     */
    upload: function upload(artifactsList, fsDest, opts) {
      var that = this; // New handle is created for every upload request to aid multiple uploads at a time in the future

      this._uploadHandler = new Deferred(function () {
        that.postMessageToUploadIframe('cancelUpload');

        that._unloadIframe();
      });
      this._workerEndpoint = opts.endpoint;

      if (artifactsList instanceof FileList) {
        var uploadToken = {
          csrfToken: undefined,
          validForMs: undefined
        }; // Get the CsrfToken

        var csrfTokenResponseProm = SendMessageUtil.sendPayload(JSON.stringify({
          messages: {
            CreateCsrfToken: [{}]
          }
        }), RemoteEndPointsManager.getEndPointNames().WORKER_ENDPOINT);
        csrfTokenResponseProm.then(function (responses) {
          responses.messages.CreateCsrfTokenResponse.forEach(function (response) {
            if (response.messageFaults && response.messageFaults.length > 0) {// No op
            } else {
              uploadToken = {
                csrfToken: response.csrfToken,
                validForMs: response.validForMs
              };
            }
          });
          var searchParams = opts.uploadParams;
          var computeToken = searchParams.computeToken;
          var routingKey = searchParams.routingKey;

          that._initiateUpload(artifactsList, {
            uploadDestinationUrl: that._workerEndpoint + 'upload',
            computeToken: computeToken,
            routingkey: routingKey,
            fileDestination: encodeURIComponent(fsDest),
            csrfToken: encodeURIComponent(uploadToken.csrfToken)
          });
        });
        return this._uploadHandler;
      }
    },
    _initiateUpload: function _initiateUpload(artifactsList, options) {
      var that = this;

      this._eventCallBack = function (event) {
        switch (event.data.type) {
          case 'updateProgress':
            // TODO: Fix upload progress incorrect bytes (g2893419), previous fix for g2737289 reverted
            that._uploadHandler.progress({
              loaded: event.data.loaded,
              total: event.data.total
            });

            break;

          case 'uploadFinished':
            that._uploadHandler.resolve({
              status: event.data.status,
              response: event.data.response
            });

            that._unloadIframe();

            break;

          case 'uploadError':
            that._uploadHandler.reject({
              status: event.data.status,
              response: event.data.response
            });

            break;

          default:
            break;
          // Do nothing.
        }
      };

      options.postMessage = this._eventCallBack;
      this._ReplaceUploadIframe = new ReplaceUploadIframe(options);
      this.postMessageToUploadIframe(artifactsList);
    },
    _unloadIframe: function _unloadIframe() {
      this._ReplaceUploadIframe = null;
    },
    getHostName: function getHostName(url) {
      var parsedUrl = HtmlUtils.parseUrl(url);
      return parsedUrl.hostname;
    },
    postMessageToUploadIframe: function postMessageToUploadIframe(message) {
      if (this._ReplaceUploadIframe) {
        this._ReplaceUploadIframe.handleMessage({
          data: message
        });
      }
    }
  });
});
//# sourceMappingURL=UploadToWorker.js.map
